import { DICTIONARY } from '../constants';

export const labels: { [key: string]: string } = {
  'company/name': DICTIONARY.LegalNameOfUSCompany,
  'employeeData/email': 'Email',
  'employeeData/firstname': 'First name',
  'employeeData/lastname': 'Last name',
  'employeeData/spouse': 'Spouse',
  'employeeData/dependents': 'Dependents',
  'employmentData/salary': 'Offered salary',
  'employmentData/startDate': 'Start date',
  'employmentData/location': 'Physical working address',
  'employmentData/premiumProcessing': 'Premium processing',
  'employeeData/employeeId': 'Employee ID',
  'foreignNational/employeeId': 'Employee ID',
  requestedProcess: 'Requested process',
  resumeID: 'Resume',
};

export default labels;
